
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Projekt Gemini',
	'appExit': 'Jít na úvodní stránku',


	'widgetsListLabel': 'Seznam modulů widget. Vyberte modul widget a přidejte ho stisknutím klávesy Enter.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Aktuální',
	'dirty': 'Neaktuální',
	'conflict': 'Konflikt při ukládání zobrazení',
	'error': 'Problém při ukládání zobrazení',
	'failure': 'Nelze navázat spojení se serverem',
	'saveFailed': 'Zobrazení nelze uložit',

	'wa_insync': 'Uložené položky',
	'wa_conflict': 'Konflikt při ukládání zobrazení',
	'wa_error': 'Zobrazení nelze uložit',
	'wa_failure': 'Nelze navázat spojení se serverem',

	// Menu Labels
	'changeDisplay': 'Změnit zobrazení',
	'changeToColumnChart': 'Změnit na sloupcový graf',
	'changeToBubbleChart': 'Změnit na bublinový graf',
	'toggleMoveHandles': 'Přepnout úchyty přesunu',
	'undo': 'Zpět',
	'redo': 'Znovu',
	'mode': 'Změnit režim',

	'untitled': 'Bez nadpisu',
	'remove': 'Odebrat',
	'editTitle': 'Upravit nadpis',
	'edit': 'Upravit',
	'done': 'Hotovo',

	// Data tray
	'dataTrayHandleOpenLabel': 'Otevřít datovou zásuvku',
	'dataTrayHandleCloseLabel': 'Zavřít datovou zásuvku',

	// Dialogs
	'dlg_loading': 'Načítání...',
	'dlg_ok': 'OK',
	'dlg_create': 'Vytvořit',
	'dlg_cancel': 'Storno',
	'dlg_close': 'Zavřít',
	'dlg_update': 'Aktualizovat',
	'dlg_renameBoardTitle': 'Přejmenovat tento objekt',
	'dlg_renameDatasetTitle': 'Přejmenovat tuto datovou sadu',
	'dlg_renameSceneTitle': 'Přejmenovat tuto scénu',
	'dlg_NameLabel': 'Název:',
	'dlg_NewNameLabel': 'Nový název:',
	'dlg_DefaultNameWithDataSet': 'Zobrazení %{name}',
	'dlg_ShareTitle': 'Sdílet obsah',
	'dlg_UnshareTitle': 'Odebrat sdílení obsahu',
	'dlg_ShareUser': 'ID uživatele:',
	'dlg_NewColumnLabel': 'Nový název výpočtu',

	'dlg_new': 'Nový...',
	'dlg_open': 'Otevřít...',
	'dlg_makeACopy': 'Vytvořit kopii',
	'dlg_rename': 'Přejmenovat...',
	'dlg_moreToCome': 'Více akcí se připravuje...',

	'dlg_use': 'Použití',

	'dlg_RelinkDatasetTitle': 'Nahradit datovou sadu \'%{datasetName}\' pomocí...',

	'open_error': 'Při otevření zobrazení došlo k problému.',

	// Delete Board
	'del_dialogTitle': 'Potvrďte odstranění',
	'del_itemMsg': 'Opravdu chcete odstranit položku \'%{name}\'?',
	'del_itemsMsg': 'Opravdu chcete odstranit %{count} položek?',
	'del_deleteErr': 'Nelze odstranit položku \'%{name}\'.',

	// List Sorting
	'dlg_ascending': 'vzestupně',
	'dlg_descending': 'sestupně',
	'dlg_custom': 'vlastní',
	'dlg_none': 'žádný',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Hledat',

	'searchHint': 'Prohledat všechna data',
	'clearSearchResult': 'Vymazat výsledky vyhledávání',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Kruh',
	'shapesHexagon': 'Šestiúhelník',
	'shapesLine': 'Čára',
	'shapesOctagon': 'Osmiúhelník',
	'shapesPentagon': 'Pětiúhelník',
	'shapesSquare': 'Hranaté',
	'shapesTriangle': 'Trojúhelník',
	'shapesDiamond': 'Kosočtverec',
	'shapesTitle': 'Vlastnosti tvaru', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Zaoblený čtverec',
	'shapesStar': 'Hvězda',
	'shapesChevron': 'Mřížkování',
	'shapesBadge_ribbon': 'Pruh odznaků',
	'shapesBadge': 'Odznak',
	'shapesHeart': 'Srdce',
	'shapesExclamation': 'Vykřičník',
	'shapesTrendingup': 'Stoupající trend',
	'shapesTrendingdown': 'Klesající trend',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Lidé',
	'shapesFemale': 'Žena',
	'shapesHappyface': 'Spokojený výraz',
	'shapesMale': 'Muž',
	'shapesMan': 'Člověk',
	'shapesNeutralface': 'Neutrální výraz',
	'shapesSadface': 'Smutný výraz',
	'shapesShakehands': 'Podání rukou',
	'shapesThumbsdown': 'Palec dolů',
	'shapesThumbsup': 'Palec nahoru',
	'shapesWoman': 'Žena',

	// Weather and places
	'shapesPlacesWeatherCat': 'Místa & počasí',
	'shapesCity': 'Město',
	'shapesCloud': 'Mrak',
	'shapesEducation': 'Vzdělání',
	'shapesGovernment': 'Vláda',
	'shapesHalfcloud': 'Poloviční mrak',
	'shapesHouse': 'Domeček',
	'shapesMoon': 'Měsíc',
	'shapesRain': 'Déšť',
	'shapesSunny': 'Slunce',

	//Vehicles
	'shapesVehiclesCat': 'Vozidla',
	'shapesAirplane': 'Letadlo',
	'shapesCar': 'Automobil',
	'shapesShip': 'Loď',
	'shapesShoppingcart': 'Nákupní vozík',
	'shapesTrain': 'Vlak',
	'shapesTruck': 'Nákladní vůz',

	//Objects
	'shapesObjectsCat': 'Objekty',
	'shapesBook': 'Kniha',
	'shapesBriefcase': 'Kufřík',
	'shapesCalendar': 'Kalendář',
	'shapesCheck': 'Šek',
	'shapesClock': 'Hodiny',
	'shapesDesktop': 'Stůl',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Jídlo',
	'shapesGear': 'Výbava',
	'shapesHealth': 'Zdraví',

	'shapesIdea': 'Nápad',
	'shapesMobile': 'Mobil',
	'shapesMoney_bill': 'Bankovka',
	'shapesMoney_coin': 'Mince',
	'shapesPiggybank': 'Pokladnička',
	'shapesStackofpaper': 'Stoh papírů',
	'shapesStickynote1': 'Nálepka 1',
	'shapesStickynote2': 'Nálepka 2',
	'shapesTarget': 'Cíl',
	'shapesTool': 'Nástroj',

	'shapesUmbrella': 'Deštník',

	'shapesBrain': 'Mozek',
	'shapesSkull': 'Lebka',
	'shapesEye': 'Oko',

	// Arrows shapes
	'shapesArrowsCat': 'Šipky',
	'shapesRightArrow': 'Šipka vpravo',
	'shapesLeftArrow': 'Šipka vlevo',
	'shapesDoubleArrow': 'Obousměrná šipka',
	'shapesCurvedArrow': 'Zahnutá šipka',

	// Callouts shapes
	'shapesCalloutsCat': 'Bubliny',
	'shapesRectCallout': 'Označení',

	// Images
	'imagesCat': 'Obrázky',
	'imageWidgetTitle': 'Modul widget obrázku',
	'imgUrl': 'Adresa URL obrázku',
	'noImgSelected': 'Není vybrán žádný obrázek.',
	'enterImgUrl': 'Sem zadejte adresu URL obrázku',
	'imgPasteLink': 'Vložte adresu URL a uložte ji stisknutím klávesy Enter.',
	'imgResizeToFit': 'Změnit velikost podle obrázku',
	'imgHeight': 'Výška:',
	'imgWidth': 'Šířka:',
	'imgTransparency': 'Průhlednost:',
	'imgMissingUrl': 'Chybí adresa URL obrázku.',
	'imgUrlValidationError': 'Adresa URL obrázku je neplatná.',
	'imgUrlInvalidDomainError': 'Adresa URL obrázku odkazuje na doménu, kterou neschválil váš administrátor. Domény schválené vaším administrátorem jsou následující: "%{domains}".',
	'notPositiveNumberError': 'Pouze kladné hodnoty',

	// line shape
	'propStrokeWidth': 'Tloušťka čáry',
	'propStrokeDashArray': 'Styl čáry',
	'propStrokeSolidline': 'Plná čára',
	'propStrokeLineCap': 'Zakončení čáry',
	'propStrokeLineCapButt': 'Tupé',
	'propStrokeLineCapRound': 'Kulaté',
	'propStrokeLineCapSquare': 'Hranaté',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Přehrát',
	'dataPlayerValueListLabel': 'Hodnoty přehrávače dat',
	// Text Widget
	'textWidgetTitle': 'Textový modul widget',
	'textStyle': 'Styly',
	'textStyleDescription': 'Předformátované styly textu',
	'textTitleStyle': 'Nadpis',
	'textTitleSmallStyle': 'Malý nadpis',
	'textSubtitleStyle': 'Podtitul',
	'textBodyStyle': 'Tělo',
	'textBodySmallStyle': 'Malý text',
	'textCaptionStyle': 'Titulek',
	'textQuoteStyle': 'Citace',
	'textQuoteSmallStyle': 'Malá citace',
	'textResponsiveStyle': 'Automatická velikost',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Nitková čára',
	'textFontFamilySubClassThin': 'Tenké',
	'textFontFamilySubClassThinItalic': 'Tenká kurzíva',
	'textFontFamilySubClassExtraLight': 'Velmi slabé',
	'textFontFamilySubClassExtraLightItalic': 'Velmi slabá kurzíva',
	'textFontFamilySubClassLight': 'Světlý',
	'textFontFamilySubClassLightItalic': 'Slabá kurzíva',
	'textFontFamilySubClassRegular': 'Regulární',
	'textFontFamilySubClassRegularItalic': 'Normální kurzíva',
	'textFontFamilySubClassItalic': 'Kurzíva',
	'textFontFamilySubClassMedium': 'Střední',
	'textFontFamilySubClassMediumItalic': 'Střední kurzíva',
	'textFontFamilySubClassHeavy': 'Těžké',
	'textFontFamilySubClassHeavyItalic': 'Těžká kurzíva',
	'textFontFamilySubClassDemiBold': 'Polotučné',
	'textFontFamilySubClassDemiBoldItalic': 'Polotučná kurzíva',
	'textFontFamilySubClassBold': 'Tučně',
	'textFontFamilySubClassBoldItalic': 'Tučná kurzíva',
	'textFontFamilySubClassExtraBold': 'Extra tučné',
	'textFontFamilySubClassExtraBoldItalic': 'Extra tučná kurzíva',
	'textFontFamilySubClassBlack': 'Černá',
	'textFontFamilySubClassBlackItalic': 'Černá kurzíva',
	'textFontFamilySubClassStencil': 'Šablona',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Písmo s automatickou velikostí',
	'responsiveCoachmarkContents': 'Velikost písma se automaticky přizpůsobí změně velikosti tohoto textového typu. Velikost písma můžete nastavit ve vlastnostech textu.',

	'propText': 'Podrobnosti textu', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Vlastnosti textu', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Velikost písma',
	'textFontFamily': 'Rodina písem',
	'textFontWeight': 'Váha písma', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': 'Barva',
	'textLineHeight': 'Výška řádku',
	'textIndentation': 'Odsazení',
	'textIncreaseIndentation': 'Zvětšit odsazení',
	'textDecreaseIndentation': 'Zmenšit odsazení',
	'textInnerMargins': 'Vnitřní okraje (px)',

	// Widget Properties
	'propImageLink': 'Odkaz obrázku',
	'propMissingURL': 'Zadat adresu URL',
	'propImgTop': 'Vlastnosti obrázku', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Obecné vlastnosti', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Obecné', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Obecné', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Barva výplně', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Barva textu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Barva ohraničení',
	'propBorderRadius': 'Poloměr rohu (pixely)',
	'propShowBorderInPreview': 'Zobrazit vybrané ohraničení v náhledu',
	'propMaintainAxisScales': 'Zachovat měřítka osy',
	'propShowItemLabel': 'Zobrazit popisek položky',
	'propHideLegend': 'Skrýt legendu',
	'propColorPalette': 'Paleta',
	'propLegendPosition': 'Poloha legendy',
	'propHideAxisTitleLabels': 'Skrýt nadpisy os',
	'propLineColor': 'Barva čáry',
	'propBubbleColor': 'Barva bublin',
	'propInterpolation': 'Plynulý čárový',
	'propElementColor': 'Barva prvku vizualizace',
	'propSymbolShape': 'Tvar symbolu',
	'propHeatScalePalette': 'Pořadí barev',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Tmavší barvy reprezentují nižší hodnoty.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Tmavší barvy reprezentují vyšší hodnoty.',
	'propImageDetails': 'Podrobnosti obrazu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Podrobnosti webové stránky', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Podrobnosti médií', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Zadejte adresu URL a stiskněte klávesu Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Poloha a styl',
	'propPositionLabel': 'Poloha', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'Pozice X (%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Pozice Y (%{unit})',
	'propResizeLabel': 'Velikost', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': 'Šířka',
	'propResizeWidth': 'Šířka (%{unit})',
	'propResizeHeight_v1': 'Výška',
	'propResizeHeight': 'Výška (%{unit})',
	'propRotateLabel_v1': 'Otočit',
	'propRotateLabel': 'Otočit (°)',
	'propRotateAngle': 'Úhel', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Množství ikon',
	'propScaleDescription': 'Vyberte množství ikon.',
	'propScaleFew': 'Nízké',
	'propScaleDefault': 'Výchozí',
	'propScaleMany': 'Vysoké',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Tato hodnota musí být číselná.',

	'mediaAriaLabel': 'Vstup adresy URL',
	'dropdownAriaLabel' : 'Rozevírací',
	'ariaGroupLabel': 'Kategorie rozevíracího seznamu: %{cateoryLabel} položka: %{itemLabel}. Rozbalení provedete stisknutím šipky dolů. Pomocí šipek můžete seznamem procházet a klávesou Escape ho sbalíte.',
	'colorNoFillLabel': 'Bez výplně',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Poslední aktualizace: před %{timeInterval}',
	'widgetTimer': 'Časovač modulu widget',

	// Theme colors
	'transparent': 'Bez barvy',
	'white': 'Bílá',
	'lightGrey': 'Světle šedá',
	'grey': 'Šedá',
	'darkGrey': 'Tmavě šedá',
	'black': 'Černá',
	'lightBlue': 'Světle modrá',
	'blue': 'Modrá',
	'darkBlue': 'Tmavě modrá',
	'yellow': 'Žlutá',
	'orange': 'Oranžová',
	'lime': 'Limetková',
	'green': 'Zelená',
	'peach': 'Broskvová',
	'red': 'Červená',
	'violet': 'Fialová',
	'aqua': 'Akvamarínová',
	'purple': 'Nachová',
	'plum': 'Švestková',
	'gray10': 'Šedá 10',
	'gray20': 'Šedá 20',
	'gray30': 'Šedá 30',
	'gray50': 'Šedá 50',
	'gray60': 'Šedá 60',
	'gray70': 'Šedá 70',
	'gray80': 'Šedá 80',
	'gray90': 'Šedá 90',
	'gray100': 'Šedá 100',
	'blue50': 'Modrá 50',
	'blue60': 'Modrá 60',
	'blue70': 'Modrá 70',
	'green40': 'Zelená 40',
	'green50': 'Zelená 50',
	'red50': 'Červená 50',
	'red60': 'Červená 60',


	//Theme Palette Labels
	'themeLabel': 'Motiv',
	'paletteLabel': 'Paleta IBM %{number}',
	'heatPaletteLabel': 'Teplotní paleta IBM %{number}',
	'conditionalPaletteLabel': 'Podmíněná paleta IBM %{number}',
	'carbonPaletteXLight': 'Motiv Carbon X světlý',
	'carbonPaletteXDark': 'Motiv Carbon X temný',
	'carbonPalettePurple': 'Nachová',
	'carbonPaletteTeal': 'Modrozelená',
	'carbonPaletteCyan': 'Azurová',
	'carbonPaletteMagenta': 'Purpurová',
	'carbonPalettePurpleTeal': 'Nachová/modrozelená',
	'carbonPaletteCyanMagenta': 'Azurová/purpurová',
	'carbonPaletteGreenRed': 'Zelená/červená',
	'carbonPaletteGreenYellowRed': 'Zelená/žlutá/červená',
	'carbonPalettePurpleTealConvergent': 'Nachová/modrozelená/konvergentní',
	'carbonPaletteCyanMagentaConvergent': 'Azurová/purpurová/konvergentní',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Světlá paleta IBM',
	'userPaletteColor_defaultTheme': 'Výchozí paleta IBM',
	'userPaletteColor_darkTheme': 'Tmavá paleta IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Barva pozadí',
	'propLayoutPositioning': 'Umístění rozvržení',
	'propLayoutRelative': 'Relativní',
	'propLayoutAbsolute': 'Absolutní',
	'propLayoutPositioningCoachmarkTitle': 'Vybrat styl rozvržení',
	'propLayoutPositioningCoachmarkContent': 'Při relativním rozvržení se velikost a pozice modulů widget upravuje podle obrazovky. Moduly widget se při absolutním rozvržení zobrazují přesně podle vámi zvolené velikosti a umístění v zobrazení bez ohledu na velikost obrazovky.',
	'gridText': 'Zobrazit mřížku',
	'snapText': 'Přichytávat k mřížce',
	'snapObjectsText': 'Přichytávat k objektům',
	'fitPageText': 'Přizpůsobit stránce',
	'gridLabel': 'Mřížka',
	'heightUnit': 'h',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Velikost stránky',
	'propPageSizePresetAriaLabel': 'Přednastavená velikost stránky',
	'propPageSizePreset_v1': 'Přednastavená',
	'propPageSizePreset': 'Velikost stránky',
	'propPageSizePresetCustom': 'Vlastní',
	'propPageSizePreset16x9': 'Obrazovka 16:9',
	'propPageSizePreset4x3': 'Obrazovka 4:3',
	'propPageSizePresetInfographic': 'Infografika',
	'propPageSizeWidth_v1': 'Šířka',
	'propPageSizeWidth': 'Šířka (px)',
	'propPageSizeHeight_v1': 'Výška',
	'propPageSizeHeight': 'Výška (px)',
	'propPageSizeWidthAriaLabel': 'Šířka velikosti stránky',
	'propPageSizeHeightAriaLabel': 'Výška velikosti stránky',
	'propPageSizeAdjustedMessage': 'Velikost stránky byla zvětšena, protože položka nedosahovala minimální hodnoty nebo by se na panel dashboard nevešla.',
	'propTabShow': 'Zobrazit karty',
	'propShowTabsInPreview': 'Zobrazit karty v náhledu',
	'multilingualDashboardsLabel': 'Jazyky',
	'multilingualDashboardsDefault': '%{defaultLanguage} - Výchozí',
	'multilingualDashboardsAddLinkText': 'Přidat další jazyk',
	'multilingualDashboardsSelect': 'Vybrat',
	'multilingualDashboardsButtonLabel': 'Přidat',
	'multilingualDashboardTranslationMode': 'Nyní jste v režimu překladu (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Hotovo',
	'multilingualDashboardRemainingStrings': 'Zbývající překlady: %{numTranslationsLeft}',
	'multilingualDashboardRemainingString': 'Zbývající překlady: 1',
	'multilingualDashboardsSetDefault': 'Nastavit výchozí jazyk',
	'multilingualDashboardIconMore': 'Další akce pro jazyk %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Přeložitelná oblast',
	'multilingualDeleteTitle': 'Odstranit jazyk',
	'multilingualDeleteLanguageWarning': 'Opravdu chcete odstranit jazyk \'%{language}\'?',
	'multilingualSelectLanguage': 'Vybrat jazyk',
	'confirmLayoutStyleUpgradeTitle': 'Použít na všechny karty',
	'confirmLayoutStyleUpgrade': 'Chcete tento styl rozvržení použít na všechny karty na panelu dashboard?',
	'defaultBackgroundColorLabel': 'Výchozí',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Odstranit',
	'tabDeleteDialogTitle': 'Odstranit tuto kartu?',
	'tabDeleteDialogMessage': 'Bude odstraněn také veškerý obsah této karty.',

	// Vis widget
	'propVisTypeReturn': 'Typy vizualizace',
	'propVisDetails': 'Podrobnosti',

	// Alignment picker
	'propAlignPickTop': 'Zarovnat nahoru',
	'propAlignPickRight': 'Zarovnat vpravo',
	'propAlignPickBottom': 'Zarovnat dolů',
	'propAlignPickLeft': 'Zarovnat vlevo',
	'propAlignPickCenter': 'Zarovnat na střed',
	'propAlignPickMiddle': 'Zarovnat doprostřed',
	'propAlignPicker': 'Vodorovné zarovnání',
	'propVerticalAlignPicker': 'Svislé zarovnání',

	// Toolbar picker
	'propToolbarPickBold': 'Tučně',
	'propToolbarPickUnderline': 'Podtržení',
	'propToolbarPickItalic': 'Kurzíva',
	'propToolbarPickJustifyLeft': 'Zarovnat vlevo',
	'propToolbarPickJustifyCenter': 'Zarovnat na střed',
	'propToolbarPickJustifyRight': 'Zarovnat vpravo',
	'propToolbarPickJustify': 'Zarovnat',

	'propList': 'Seznam',
	'propOrderedList': 'Seřazený seznam',
	'propUnorderedList': 'Neseřazený seznam',

	// Symbol shapes
	'propCircle': 'Kruh',
	'propTriangle': 'Trojúhelník',
	'propSquare': 'Hranaté',
	'propRect': 'Obdélník',
	'propStar': 'Hvězda',
	'propCross': 'Kříž',
	'propPlus': 'Plus',
	'propPoly': 'Mnohoúhelník',


	// True and false selection
	'propTrue': 'Pravda',
	'propFalse': 'Nepravda',

	// Position selection
	'propLeft': 'Vlevo',
	'propRight': 'Vpravo',
	'propTop': 'Nahoře',
	'propBottom': 'Dole',

	// Interpolation options
	'propSmooth': 'Hladká',
	'propStraight': 'Přímá',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Seznam', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Přesunout doleva', // screen reader
	'srWidgetMoveUp': 'Přesunout nahoru', // screen reader
	'srWidgetMoveRight': 'Přesunout doprava', // screen reader
	'srWidgetMoveDown': 'Přesunout dolů', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Zvýšit velikost proporcionálně', // screen reader
	'srWidgetResizeSmaller': 'Snížit velikost proporcionálně', // screen reader
	'srWidgetResizeBiggerV': 'Zvýšit velikost svisle', // screen reader
	'srWidgetResizeSmallerV': 'Snížit velikost svisle', // screen reader
	'srWidgetResizeBiggerH': 'Zvýšit velikost vodorovně', // screen reader
	'srWidgetResizeSmallerH': 'Snížit velikost vodorovně', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Otočit ve směru hodinových ručiček', // screen reader
	'srWidgetRotateCCW': 'Otočit proti směru hodinových ručiček', // screen reader

	// Recommended types
	'visChange': 'Změnit vizualizaci',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Vizualizace',
	'chartLabel': 'Graf %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Stisknutím klávesy F12 můžete procházet modulem widget.',
	'f10KeyDescription': 'Stisknutím klávesy F10 spustíte zobrazení fokusu modulu widget.',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} s hodnotou %{value}',

	'shapeColorLabel': 'Barva tvaru',
	'showLegendLabel': 'Zobrazit legendu',

	//Webpage
	'webpageWidgetTitle': 'Modul widget webové stránky',
	'webpagePasteLink': 'Vložte adresu URL a uložte ji stisknutím klávesy Enter.',
	'propWebpageLink': 'Adresa URL webové stránky',
	'propWebpageTitle': 'Nadpis webové stránky',
	'propWebpageTitleDescription': 'Nadpis webové stránky',
	'webpageUrl': 'Adresa URL webové stránky',
	'noWebpageSelected': 'Není vybrána žádná webová stránka.',
	'enterWebpageUrl': 'Sem zadejte adresu URL webové stránky',
	'propWebpageTop': 'Vlastnosti webové stránky', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Adresa URL webové stránky chybí.',
	'webpageUrlValidationError': 'Adresa URL webové stránky je neplatná.',
	'webpageHttpValidationError': 'Tato webová stránka musí být otevírána pomocí odkazu HTTPS.',
	'webpageInvalidDomainError': 'Adresa URL webové stránky odkazuje na doménu, kterou neschválil váš administrátor. Domény schválené vaším administrátorem jsou následující: "%{domains}".',

	//VizState
	'vzErrorLoading': 'Nelze načíst vizualizaci',
	'vzErrorLoadingMissingData': 'Nelze načíst vizualizaci, chybí data kontextu.',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Modul widget média',
	'mediaPasteLink': 'Vložte adresu URL a uložte ji stisknutím klávesy Enter.',
	'mediaUrl': 'Adresa URL média',
	'noMediaSelected': 'Není vybráno žádné médium.',
	'enterMediaUrl': 'Sem zadejte adresu URL média',
	'videoHeight': 'Výška:',
	'videoWidth': 'Šířka:',
	'propMediaLink': 'Odkaz na média',
	'propMediaTitle': 'Nadpis médií',
	'propMediaTitleDescription': 'Nadpis médií',
	'propMediaTop': 'Vlastnosti médií', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Chybí adresa odkazu na média.',
	'mediaUrlValidationError': 'Adresa URL souboru s médii je neplatná.',
	'mediaUnknownValidationError': 'Tento typ médií není podporován.',
	'mediaHttpValidationError': 'Tento soubor médií musí být otevírán pomocí odkazu HTTPS.',
	'mediaInvalidDomainError': 'Adresa URL souboru médií odkazuje na doménu, kterou neschválil váš administrátor. Domény schválené vaším administrátorem jsou následující: "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Vlastnosti', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Datová sada',
	'dataViewsLabel': 'Zobrazit',
	'columnQuality': 'Kvalita dat',
	'columnProperties': 'Vlastnosti dat',

	'dataQuality': 'Kvalita dat',
	'dataQualityRowCount': 'Počet řádků',
	'dataQualityDistribution': 'Rozdělení',
	'dataRowLabel': 'Data',

	// Modelling UI
	'typeColumn': 'Typ',
	'modellingColumnType': 'Typ',
	'modellingColumnAggregation': 'Agregované',
	'modellingColumnUsage': 'Použití',
	'modellingColumnSort': 'Řadit',
	'modellingColumnFormat': 'Formát',
	'modellingColumnCategory': 'Kategorie',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Načítání...',

	'modellingProcessing': 'Zpracování...',
	'modellingImport': 'Importovat',
	'modellingReimport': 'Opětný import',
	'modellingDatasourceTitle': 'Zdroj dat',
	'modellingImportStartedTitle': 'Import byl zahájen',
	'modellingImportStartedText': 'Importování dat může určitou dobu trvat.\n\n(Během importu dat můžete vytvářet zobrazení.)',
	'importDatasourceTitle': 'Připojení',
	'dropHere': 'Přetažením sem vytvořte nový zdroj dat...',
	'browseButton': 'Procházet',
	'errorNoData': 'Neexistují žádná data ke zpracování.',
	'errorNoFile': 'Neexistuje žádný soubor k načtení.',
	'errorUploadFailed': 'Nelze odeslat.',
	'uploadSucceessful': 'Odeslání bylo úspěšné',
	'del_datasourceTitle': 'Odstranit datovou sadu',
	'del_datasourceMsg': 'Opravdu chcete odstranit položku \'%{name}\'?',
	'modellingFileUpdate': 'Aktualizovat',
	'modellingFileUpdateTitle': 'Aktualizovat datovou sadu',
	'modellingFileUpdateDescription': 'Opravdu chcete aktualizovat \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Probíhá aktualizace \'%{name}\'',
	'modellingUpdateStartedTitle': 'Byla zahájena aktualizace importu',
	'modellingUpdateStartedText': 'Aktualizace dat může určitou dobu trvat.\n\n(Během aktualizace dat můžete vytvářet zobrazení.)',
	'modellingErrorImportUploadNoFile': 'Žádný soubor k odeslání.',
	'modellingErrorImportUploadFailed': 'Nelze odeslat.',
	'modellingErrorImportUploadInvalidType': 'Typ souboru je neplatný.',
	'modellingErrorImportUploadTableFailed': 'Nelze získat tabulky.',
	'modellingIntentResultsTitle': 'Vyberte navrhovanou datovou sadu k použití',
	'modellingColumnViewRelationships': 'Zobrazit související tabulky',
	'modellingTableRelatedTables': 'Tabulky související s \'%{name}\'',
	'modellingTable': '%{name} - Tabulka',
	'modellingColumnIncludedInDataSet': 'Přidáno',
	'modellingDataSet': 'Datová sada',
	'modellingViewInDataSet': 'Zobrazit v datové sadě',
	'modellingViewRelatedTables': 'Zobrazit související',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Nebyly nalezeny žádné související tabulky',

	'modellingValidatingDataset': 'Ověřování...',
	'datasetFinishedRefreshing': 'Datová sada %{datasetName} byla obnovena.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Interpretovat cestu spojení:',
	'modellingJoinColumns': 'Definovat cestu spojení pro tabulku: %{name}',
	'modellingJoinToTable': 'Spojení s tabulkou: %{name}',

	// Data Quality
	'excluded': 'Vyloučené',
	'metricPrefixThousand': 'k',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filtr',
	'modellingColumnSortNone': 'Vymazat řazení',
	'modellingColumnSortAsc': 'Seřadit vzestupně',
	'modellingColumnSortDesc': 'Seřadit sestupně',
	'modellingColumnRemove': 'Odebrat tento sloupec',

	// Import File Browser
	'dropboxPageTitle': 'Nové připojení Dropbox',
	'sizeColumn': 'Velikost',

	//Modelling Column Property Values
	'dataType_string': 'Řetězec',
	'dataType_date': 'Datum',
	'dataType_integer': 'Celočíselný',
	'dataType_double': 'Dvojitá',
	'dataType_float': 'Plovoucí',
	'dataType_boolean': 'Logický',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Počet',
	'defaultAggregation_countdistinct': 'Počet jedinečných',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Průměr',
	'defaultAggregation_sum': 'Suma',
	'defaultAggregation_auto': 'Automaticky (%{aggregationType})',

	'type_fact': 'Fakt',
	'type_attribute': 'Atribut',

	'defaultSort_none': 'Neřadit',
	'defaultSort_asc': 'Seřadit vzestupně',
	'defaultSort_desc': 'Seřadit sestupně',

	'category_none': 'Žádný',
	'category_location': 'Umístění',
	'category_monetary': 'Peněžní',
	'category_time': 'Čas',

	// Root menu
	'rootMenuTitle': 'Hlavní nabídka',

	'errorMessageTitle': 'Chyba',
	'errorMessageDetails': 'Detaily: ',
	'errorMessageTitleAssetAlreadyExists': 'Aktivum již existuje',

	'defaultTabTitle': 'Karta %{index}',
	'tabAddBtnTitle': 'Přidat novou kartu',
	'defaultInfographicTitle': 'Info grafika',

	'unsupportedConditionalFormattingEncountered': 'Podmíněné formátování se na některé sloupce již neuplatňuje.',


	// Homepage View
	'nameColumn': 'Název',
	'creatorColumn': 'Vytvořil',
	'creationDateColumn': 'Datum vytvoření',
	'versionColumn': 'Verze',
	'modifiedColumn': 'Poslední úpravy',

	'filterBy': 'Filtrovat položky',
	'allFilter': 'Všechny položky',
	'createdByMeFilter': 'Vytvořeno mnou',
	'sharedWithMeFilter': 'Sdíleno se mnou',
	'favoritesFilter': 'Mé oblíbené položky',
	'recentsFilter': 'Nedávno přidané',
	'sortBy': 'Seřadit podle',

	// Sort Menu
	'sortModified': 'Změněno',
	'sortUpdated': 'Aktualizováno',
	'sortName': 'Název',

	'viewAs': 'Zobrazit jako',
	'thumbnailsView': 'Zobrazit jako miniatury',
	'listView': 'Zobrazit jako seznam',
	'createMenu': 'Vytvořit',
	'newAppItem': 'Panel dashboard',
	'newDataSet': 'Datová sada',

	'menuSelectionState_a11y': 'Selektor "%{item}" nastaven na "%{selectedItem}"',

	'unableToShareItem': 'Nelze sdílet položku "%{item}".',
	'toastFetchingContent': 'Získávání dalšího obsahu...',
	'unableToGetData': 'Nelze získat obsah.',
	'unableToFavorite': 'Nelze změnit stav Oblíbené.',
	'hpErrorMissingRequiredOptions': 'Chybí vyžadované volby iInicializace',
	'unableToOpenBoard': 'Nelze otevřít "%{name}".',
	'unableToDuplicateBoard': 'Nelze duplikovat "%{name}".',
	'unableToCreateBoard': 'Nelze vytvořit "%{name}".',
	'unableToCreateBoardNameConflict': 'Aktivum se stejným názvem již existuje.',

	// DataSet Detail View
	'status': 'Stav',
	'numberOfRows': 'Řádky',
	'importWarnings': 'Varování',
	'lineNumbers': 'Čáry',
	'excerptFromSource': 'Výňatek',
	'reason': 'Důvod',
	'numberOfRowsDropped': 'řádků zrušeno',
	'oneRowDropped': '1 řádek byl zrušen',

	// Type Menu
	'typeMenuLabel': 'Typ',
	'dashboardsLabel': 'Panely dashboard',
	'datasetsLabel': 'Datové sady',
	'storiesLabel': 'Scénáře',
	'allLabel': 'Všechny typy',

	// Board Page View App Bar
	'datasets': 'Datové sady',
	'settings': 'Vlastnosti',
	'add': 'Přidat',
	'widgets': 'Moduly widget',
	'dashboardProperties': 'Vlastnosti panelu dashboard',
	'searchPanel' : 'Hledat',
	'pins': 'Kolekce',
	'pinsOld': 'Moje fixace',
	'pinsDateFilterHeading' : 'Fixované datum',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} fixace |||| %{smart_count} fixací',
	'pinSearch': 'Hledat',
	'pinSearchOld': 'Hledat fixace',
	'pinListView': 'Zobrazení seznamu',
	'pinIconView': 'Zobrazení ikon',
	'pinRemove': 'Odebrat',
	'pinCreate': 'Vytvořit',
	'pinDeleteError': 'Nelze odstranit jedno nebo více aktiv z kolekce. Opakujte operaci později.',
	'pinDeleteErrorOld': 'Nelze odstranit jeden nebo více fixací. Opakujte operaci později.',
	'pinRetrieveError': 'Nelze načíst jeden nebo více fixací. Opakujte operaci později.',
	'NoPinsCollected': 'Žádné fixované vizualizace',
	'pinDeletedToast': 'Fixace byla zrušena.',
	'pinRenamedToast': 'Kolík byl přejmenován',
	'pinAddedToast': 'Fixace byla úspěšně přidána do seznamu Moje fixace.',
	'pinningToast': 'Zpracování fixace...',
	'pinDateFilter': 'Filtr dat',
	'pinDateFilterAll': 'Vše',
	'pinDateFilterToday': 'Dnes',
	'pinDateFilterYesterday': 'Včera',
	'pinDateFilterPastWeek': 'Minulý týden',
	'pinDateFilterPastMonth': 'Minulý měsíc',
	'pinDateFilterEarlier': 'Dříve',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Upravit nadpis',
	'toolbarActionSort': 'Řadit',
	'toolbarActionSortAscending': 'Seřadit vzestupně',
	'toolbarActionSortDescending': 'Seřadit sestupně',
	'toolbarActionSortAuto': 'Automaticky (%{sortOrder})',
	'toolbarActionFormat': 'Formátovat data',
	'toolbarActionFormatAbbreviation': 'Zkracovat',
	'toolbarActionFormatNone': 'Automaticky',
	'toolbarActionFilter': 'Filtr',
	'toolbarActionTopBottom': 'Začátek nebo konec',
	'toolbarActionAddShape': 'Přidat tvar',
	'toolbarActionRmvShape': 'Odebrat tvar',
	'toolbarActionToggleShapeDrop': 'Tvar infografiky',
	'toolbarActionToggleShapeDropTitle': 'Vytvořit infografiku',
	'toolbarActionToggleShapeDropText': 'Chcete-li vytvořit infografiku, pomocí myši do tohoto pole přetáhněte tvar.',
	'toolbarActionAggregationType': 'Shrnout',
	'toolbarDeleteActionText': 'Odebrat sloupec',
	'toolbarActionFilterLocalKeepSelected': 'Zachovat',
	'toolbarActionFilterLocalExcludeSelected': 'Vyloučit',
	'toolbarActionFilterAllKeepSelected': 'Filtr',
	'toolbarActionSimpleCalculation': 'Jednoduchý výpočet',
	'toolbarActionDrillBack': 'Zpět',
	'toolbarActionDrillUp': 'Přechod o úroveň výš',
	'toolbarActionDrillDown': 'Přejít o úroveň níž',
	'toolbarActionNavigate': 'Procházet',
	'toolbarActionCreateFilterGroup': 'Vytvořit nové připojení',
	'toolbarActionDisconnectFilterGroup': 'Přerušit všechny spoje',
	'toolbarActionLinkFilterGroup': 'Přidat k existujícímu připojení',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Přidat',
	'sidebarMultiselect': 'Přepnout na vícenásobný výběr',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} vybráno',

	'multiselectWithTotalMsg': '%{count} z %{total}',
	'sidebarGoBack': 'Přejít zpět',

	//DataSet pane
	'errorLoadingDataSets': 'Nelze načíst tuto datovou sadu',
	'errorLoadingDataSetMetaData': 'Nelze načíst tuto datovou sadu',
	'dataSetPaneLastUpdated': 'Poslední aktualizace: %{date}',
	'dataSetPaneDateUnknown': 'Neznámý',
	'sourcePaneLabel': 'Vybrané zdroje',
	'addSourceLabel': 'Přidat zdroj',
	'find_label': 'Najít',
	'navigationPathsLabel': 'Navigační cesty',

	//widgetlist
	'errorLoadingWidgetList': 'Nelze načíst objekty.',
	'errorLoadingThemeFile': 'Nelze načíst definici motivu',
	'errorLoadingLayoutFile': 'Nelze načíst zobrazení.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Nelze načíst dostupné definice zobrazení',

	'dwErrorLoadingVisualizationNotFound': 'Nelze načíst objekt, jelikož mu chybí definice vizualizace',
	'dwErrorLoadingVisualizationListNotFound': 'Nelze načíst vizualizaci.',
	'dwErrorRunningQuery': 'Nelze načíst data ze sady %{datasetName}.',
	'dwErrorGeoData': 'Máme problémy se zobrazením geografických údajů na mapě. Zvolte jiný typ vizualizace. ',
	'dwPromptSignonCancelWarning': 'Data pro tuto vizualizaci nejsou k dispozici. Poskytněte správná pověření.',
	'dwErrorMissingDataset': 'Nelze načíst vizualizaci, protože má přidruženou nedostupnou datovou sadu \'%{datasetName}\'.',
	'dwErrorRenderingVisualization': 'Nelze načíst tuto vizualizaci.',
	'dwErrorVisualizationTooSmall': 'Vizualizace je příliš malá a nemůže zobrazit v ní obsažená data. Zvětšete vizualizaci nebo omezte obsažená data.',
	'aria_label_datatable': 'Tabulka dat',
	'aria_key_navi_datatable_desc': 'Mezi buňkami můžete přecházet pomocí kláves se šipkami. Stisknutím kláves Control a Home se přesunete na první řádek, stisknutím kláves Control a End na poslední.',
	'geomapUnrecognizedLocations': 'Nerozpoznaná umístění:',
	'geomapAmbiguousLocations': 'Nejednoznačné oblasti:',

	// custom widget
	'customWidget': 'Vlastní modul widget',
	'customWidgetsTitle': 'Vlastní moduly widget',
	'noCustomWidgets': 'Žádné vlastní moduly widget',

	// Action names
	'toggleContextBar': 'Přepnout pruh kontextu',
	'delete': 'Odstranit',
	'share': 'Sdílet',
	'unshare': 'Zrušit sdílení',
	'rename': 'Přejmenovat',
	'close': 'Zavřít',
	'duplicate': 'Duplikovat',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Opakovat akci',

	'changeTemplate': 'Změnit šablonu',

	// Aggregation Types
	'sum': 'Suma',
	'count': 'Počet',
	'countdistinct': 'Počet jedinečných',
	'avg': 'Průměr',
	'min': 'Minimum',
	'max': 'Maximum',
	'custom': 'Vlastní',
	'calculated': 'Vypočteno',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% změny',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Kritéria vizualizace...',
	'QuickAddResultsHeader': 'Vizualizace dat',
	'NoQuickAddResults': 'Nic neodpovídá vašemu záměru. Vytvořit novou datovou sadu?',
	'NoQuickAddResultsRetry': 'Nebyly nalezeny žádné shody. Zkuste změnit termíny hledání.',
	'templateWidgetTitle': 'Šablona',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(prázdné)',

	'nullValueContent': '(bez hodnoty)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Filtr textu - %{columnName}',

	'textFilterSelectTab': 'Vybrat',

	'textFilterConditionTab': 'Nastavit podmínku',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Nejsou k dispozici žádné položky.',

	'textFilterEquals': 'Rovná se',
	'textFilterContains': 'Obsahuje',
	'textFilterBeginsWith': 'Začíná na',
	'textFilterEndsWith': 'Končí na',
	'textFilterDoesNotEqual': 'Nerovná se',
	'textFilterDoesNotContain': 'Neobsahuje',
	'textFilterDoesNotBeginWith': 'Nezačíná na',
	'textFilterDoesNotEndWith': 'Nekončí na',
	'textFilterSampleText': 'Například: A',

	'textFilterAndButton': 'A',
	'textFilterOrButton': 'Nebo',

	'dateFilterMessage': 'Vybrat rozsah dat',
	'dateRangeControlRegionLabel': 'Filtr rozsahu dat - %{columnName}',
	'dateFilterRangeOption': 'Volba rozsahu',
	'dateFilterDateLabel': 'Datum',
	'dateFilterBlank': '(prázdné)',
	'dateFilterBefore': 'Před',
	'dateFilterAfter': 'Za',
	'dateFilterBetween': 'Mezi',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'Datum',
	'dateIncludeBlankLabel': 'Včetně prázdného data',

	'timeTitle': 'Čas',
	'timeFilterMessage': 'Vybrat rozsah času',
	'dateTimeFilterMessage': 'Vybrat rozsah dat a času',

	'topbottomNumberOfResultsLabel': 'Počet výsledků',
	'topbottomPercentLabel': 'Procenta',
	'topbottomNumberOfResultsLimit': 'Mezi %{lower} a %{higher}',
	'topbottomSelectOption': 'Volba Začátek nebo konec',
	'topbottomOptionLabel': 'Zobrazit',
	'searchByLabel': 'Podle',
	'searchNoMatches': 'Nebyly nalezeny žádné odpovídající položky',
	'topbottomRankColumnLabel': 'Přidat sloupec očíslování pořadí do tabulky',
	'topbottomNone': 'Žádný',
	'topCount': 'Horní počet',
	'topPercent': 'Horní %',
	'bottomCount': 'Dolní počet',
	'bottomPercent': 'Dolní %',
	'topbottomSearchColumn': 'Najít sloupec',
	'searchColumnAriaLabel': 'Můžete hledat sloupec. Zadejte název sloupce, který chcete hledat, a poté pomocí šipky dolů najděte příslušný sloupec v seznamu.',
	'rankColumnLabel': 'Pořadí (%{columnLabel})',
	'topbottomClearLabel': 'Vymazat',

	'rangeFilterControlRegionLabel': 'Filtr rozsahu - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Posuvný ovládací prvek, k posunu jezdce použijte šipky vpravo a vlevo.',
	'sliderHandleLabel': 'Jezdec',
	'a11ySliderHandleLabel': 'Jezdec %{sliderValue}',
	'sliderInputLabel': 'hodnota',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Některé datové sady použité v této vizualizaci jsou nedostupné.',
	'datasetItemUnavailable': 'Tato položka datové sady je nedostupná',

	//Authoring topBottom
	'topOperator': 'Prvních',
	'bottomOperator': 'Posledních',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} podle %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Pouze tento objekt',
	'deleteTopBottom': 'Odstranit počet pro začátek nebo konec',
	'editTopBottom': 'Upravit počet pro začátek nebo konec',
	'deleteDrillState': 'Odstranit aktuální stav procházení',
	'ariaDeleteDrillStateLabel': 'Stisknutím klávesy Enter lze počet pro začátek nebo konec upravit.',
	'drillUpStateTitle': 'Přechod o úroveň výš',
	'drillDownStateTitle': 'Přechod o úroveň níž',
	'ariaEditTopBottomLabel': 'Stisknutím klávesy Enter lze počet pro začátek nebo konec upravit.',
	'ariaDeleteTopBottomLabel': 'Stisknutím klávesy Delete lze počet pro začátek nebo konec odstranit.',

	// Authoring filtering
	'dimFilterIn': 'Zahrnuje: %{in}',
	'dimFilterNotIn': 'Nezahrnuje: %{out}',
	'measureFilterBetween': 'Mezi %{lowerBound} a %{upperBound}',
	'measureFilterNotBetween': 'Ne mezi %{lowerBound} a %{upperBound}',
	'gtFilter': 'Po %{lowerBound}',
	'ltFilter': 'Před %{upperBound}',
	'notGtFilter': 'Ne po %{lowerBound}',
	'notLtFilter': 'Ne před %{upperBound}',
	'localFilterTitle': 'Pouze tento objekt',
	'globalFilterTitle': 'Všechny objekty',
	'deleteFilter': 'Odstranit filtr',
	'editFilter': 'Upravit filtr',
	'ariaEditFilterLabel': 'Stisknutím klávesy Enter lze filtr upravit.',
	'ariaDeleteFilterLabel': 'Stisknutím klávesy Delete lze filtr odstranit.',

	// Prompts
	'ariaEditPrompt': 'Po stisknutí klávesy Enter lze hodnotu výzvy k zadání upravit.',

	'moreDataIndicator': 'Vaše data byla oříznuta po %{threshold} položkách. Chcete-li zobrazit méně položek, použijte filtr.',

	// data point filtering
	'dataPointFilterTitle': 'Datové body',
	'dataPointFilterIncludeSummary': 'Zahrnuto %{valueCount} datových bodů',
	'dataPointFilterExcludeSummary': 'Vyloučeno %{valueCount} datových bodů',

	// DB2 connection page
	'db2Database': 'Databáze DB2 (%{jdbcConnection})',
	'db2Title': 'Připojit k IBM DB2',

	// Database
	'databaseConnectionMessage': 'Zadejte své údaje pro připojení databáze:',
	'connectionString': 'Řetězec databázového připojení',
	'databaseCredentials': 'Přihlašovací údaje: ',
	'databaseUserName': 'Uživatelské jméno',
	'databasePassword': 'Heslo',
	'databaseConnect': 'Připojit',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Zadejte hledaný výraz:',
	'twitterKeyword': 'Klíčové slovo',
	'twitterSearch': 'Hledat',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Nelze vytvořit zobrazení: %{error}\nSelhala operace: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtry modulu widget',
	'missingColumn': 'Chybí: %{columnLabel}',
	'missingFiltering': 'Chybí filtry pro následující ID sloupců:',
	'heatByLabel': 'Teplota podle:',
	'evColumns': 'Sloupce',
	'evLocalFilters': 'Lokální filtry',
	'evExpand': 'Rozbalit',
	'evFilterTooltip': 'Filtr',
	'evAdd': 'Přidat sloupec',

	// Navigation View
	'navigationBack': 'Zpět',

	// Pinning
	'contentPinFail': 'Nelze shromáždit obsah. Opakujte operaci později.',
	'contentPinFailOld': 'Nelze fixovat obsah. Opakujte operaci později.',
	'pinRenameFail': 'Kolík nelze přejmenovat. Zkuste to znovu později.',

	// Layouts
	'dropZoneLabel': 'Přetažením sem maximalizujte',

	//Share
	'shareDefaultPageTitle': 'Stránka %{index}',

	'nextPage': 'Následující stránka',
	'previousPage': 'Předchozí stránka',

	'assetAssembly': 'zobrazení',

	'toolbar_save': 'Uložit',
	'brgr_saveAs': 'Uložit jako',
	'brgr_refresh': 'Obnovit',

	// Save
	'saving': 'Ukládání...',
	'save_success': 'Vaše zobrazení bylo uloženo.',
	'save_failure': 'Je nám líto. Vaše zobrazení nebylo možné uložit. Opakujte operaci později.',
	'dashboard_save_success': 'Váš panel dashboard byl uložen.',

	'geminiLeave': 'Chystáte se opustit prostředí IBM Watson Analytics.',

	'warning': 'Varování',
	'missingDataSetData': 'Data pro tuto datovou sadu nejsou k dispozici. Aktualizujte datovou sadu nebo požádejte administrátora o přístup ke zdroji.',

	// Calculations
	'error_calculation_in_use': 'Vybraný výpočet se používá a nelze ho odstranit.',

	'resize': 'Změnit velikost',
	'rotate': 'Otočit',
	'moveHandle': 'Přesunout modul widget',
	'expandHandle': 'Rozbalit',
	'panHandle': 'Posouvat',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Přejít do umístění',

	// Slide out titles
	'shapeSlideoutTitle': 'Tvary',
	'textSlideoutTitle': 'Text',
	'mediaSlideoutTitle': 'Médium',
	'visualizationSlideoutTitle': 'Vizualizace',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Předaný kód JSON je neplatný. Další informace naleznete v protokolu chyb.',

	// Widget type labels
	'shape_label': 'Tvar',
	'image_label': 'Obrázek',
	'data_label': 'Graf',
	'media_label': 'Médium',
	'text_label': 'Text',
	'embedMedia_label': 'Médium',
	'youtube_label': 'Video YouTube',
	'webpage_label': 'Webová stránka',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Tvar',
	'noExtraText_shape_numbered': 'Tvar (%{number})',
	'few_shape': 'Skupina tvarů %{count}',
	'many_shape': 'Skupina tvarů %{count}',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Obrázek %{text}',
	'one_image_numbered': 'Obrázek %{text} (%{number})',
	'noExtraText_image': 'Obrázek',
	'noExtraText_image_numbered': 'Obrázek (%{number})',
	'few_image': 'Skupina obrázků %{count}',
	'many_image': 'Skupina obrázků %{count}',
	'noExtraText_text': 'Prázdné textové pole',
	'noExtraText_text_numbered': 'Prázdné textové pole (%{number})',
	'few_text': 'Skupina textových polí %{count}',
	'many_text': 'Skupina textových polí %{count}',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': 'Cube Viewer %{name}',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Kontingenční tabulka: %{values} podle %{row_level1} a %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Kontingenční tabulka: %{values} podle %{row_level1} a %{column_level1} (%{number})',
	'crosstab_has_mapping': 'Kontingenční tabulka: %{values} podle %{row_level1}',
	'crosstab_has_mapping_numbered': 'Kontingenční tabulka: %{values} podle %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Prázdná kontingenční tabulka',
	'crosstab_no_mapping_numbered': 'Prázdná kontingenční tabulka (%{number})',
	'crosstab_named': 'Kontingenční tabulka %{name}',
	'crosstab_named_numbered': 'Kontingenční tabulka %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Tabulka %{grid_cols}',
	'JQGrid_has_mapping_numbered': 'Tabulka %{grid_cols} (%{number})',
	'JQGrid_no_mapping': 'Prázdná tabulka',
	'JQGrid_no_mapping_numbered': 'Prázdná tabulka (%{number})',
	'JQGrid_named': 'Tabulka %{name}',
	'JQGrid_named_numbered': 'Tabulka %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Hierarchie %{level1}',
	'hierarchy_has_mapping_numbered': 'Hierarchie %{level1} (%{number})',
	'hierarchy_no_mapping': 'Prázdná hierarchie',
	'hierarchy_no_mapping_numbered': 'Prázdná hierarchie (%{number})',
	'hierarchy_named': 'Hierarchie %{name}',
	'hierarchy_named_numbered': 'Hierarchie %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Mapa %{categories}',
	'map_has_mapping_numbered': 'Mapa %{categories} (%{number})',
	'map_no_mapping': 'Prázdná mapa',
	'map_no_mapping_numbered': 'Prázdná mapa (%{number})',
	'map_named': 'Mapa %{name}',
	'map_named_numbered': 'Mapa %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Souhrnná hodnota %{actual}',
	'summary_has_mapping_numbered': 'Souhrnná hodnota %{actual} (%{number})',
	'summary_no_mapping': 'Prázdná souhrnná hodnota',
	'summary_no_mapping_numbered': 'Prázdná souhrnná hodnota (%{number})',
	'summary_named': 'Souhrnná hodnota %{name}',
	'summary_named_numbered': 'Souhrnná hodnota %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'KPI %{actual} podle %{sparkline.time}',
	'kpi_opt_mapping_numbered': 'KPI %{actual} podle %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'KPI %{actual}',
	'kpi_has_mapping_numbered': 'KPI %{actual} (%{number})',
	'kpi_no_mapping': 'Prázdný ukazatel KPI',
	'kpi_no_mapping_numbered': 'Prázdný ukazatel KPI (%{number})',
	'kpi_named': 'KPI %{name}',
	'kpi_named_numbered': 'KPI %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Infografika %{actual}',
	'infographicSummary_has_mapping_numbered': 'Infografika %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Prázdná infografika',
	'infographicSummary_no_mapping_numbered': 'Prázdná infografika (%{number})',
	'infographicSummary_named': 'Infografika %{name}',
	'infographicSummary_named_numbered': 'Infografika %{name} (%{number})',
	'noExtraText_youtube': 'Video YouTube',
	'noExtraText_youtube_numbered': 'Video YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'Video YouTube %{text}',
	'one_youtube_numbered': 'Video YouTube %{text} (%{number})',
	'few_youtube': 'Skupina videí YouTube %{count}',
	'many_youtube': 'Skupina videí YouTube %{count}',
	'noExtraText_embedMedia': 'Odkaz na média',
	'noExtraText_embedMedia_numbered': 'Odkaz na média (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Odkaz na média %{text}',
	'one_embedMedia_numbered': 'Odkaz na média %{text} (%{number})',
	'few_embedMedia': 'Skupina odkazů na média %{count}',
	'many_embedMedia': 'Skupina odkazů na média %{count}',
	'noExtraText_media': 'Médium',
	'noExtraText_media_numbered': 'Médium (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Médium %{text}',
	'one_media_numbered': 'Médium %{text} (%{number})',
	'few_media': 'Skupina médií %{count}',
	'many_media': 'Skupina médií %{count}',
	'noExtraText_webpage': 'Webová stránka',
	'noExtraText_webpage_numbered': 'Webová stránka (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Webová stránka %{text}',
	'one_webpage_numbered': 'Webová stránka %{text} (%{number})',
	'few_webpage': 'Skupina webových stránek %{count}',
	'many_webpage': 'Skupina webových stránek %{count}',
	'one_unknown': 'Objekt',
	'one_unknown_numbered': 'Objekt (%{number})',
	'few_unknown': 'Skupina objektů %{count}',
	'many_unknown': 'Skupina objektů %{count}',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Další',
	'previous': 'Předchozí',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Aktuální navigační skupina je %{navigation_group_name}',

	//Page Context
	'filterBlank': '(prázdné)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Nelze načíst hodnoty filtru',
	'editTimelineHighlight': 'Upravit zvýraznění',

	'filterDockChevronLeft': 'Posouvat se daty',
	'filterDockChevronRight': 'Posouvat se daty',
	'expand': 'Rozbalit',
	'collapse': 'Sbalit',

	//Reset Dashboard
	'dashboardResetTitle': 'Resetovat panel dashboard',
	'dashboardResetMessage': 'Opravdu si přejete resetovat všechny změny použité na tento panel dashboard?',
	'dashboardResetToast': 'Váš panel dashboard byl resetován.',

	//Generate PDF
	'buildingPDF': 'Vytváření souboru PDF...',
	'exportPDF': 'Export do formátu PDF',
	'pageSize': 'Velikost stránky',
	'orientation': 'Orientace',
	'filtersPresentPDF': 'Filtry aplikované na vizualizace na předchozí stránce:',
	'errorPDF': 'Nelze generovat soubor PDF. Proveďte aktualizaci a zopakujte operaci.',
	'errorPrintPDF': 'Nelze generovat soubor PDF. Zopakujte operaci.',
	'printPDFInfo': 'Zobrazit dokumentaci',
	'pdfWidget': 'Modul widget',
	'includeFilters': 'Zobrazit podrobnosti o filtru',
	'portrait': 'Na výšku',
	'landscape': 'Na šířku',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Váš panel dashboard byl upgradován. Kvůli optimálnímu výkonu proveďte nyní uložení.',

	'migratingDashboard': 'Data řídicího panelu musí být migrována, řídicí panel bude uložen po dokončení migrace...',
	'migrateDone': 'Data řídicího panelu byla migrována.',
	'migrateNoPermission': 'Data řídicího panelu musí být migrována; to vyžaduje oprávnění k zápisu; vizualizace budou vykresleny s chybou.',
	'migratingDataSourcesFailed': 'selhala migrace dat jednoho nebo více zdrojů dat',

	'ariaFullScreenMessage': 'Chcete-li ukončit režim celé obrazovky, stiskněte klávesu Esc.',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Sbalený hierarchický bublinový graf %{categories}',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Sbalený hierarchický bublinový graf %{categories} (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Prázdný sbalený hierarchický bublinový graf',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Prázdný sbalený hierarchický bublinový graf (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Sbalený hierarchický bublinový graf %{name}',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Sbalený hierarchický bublinový graf %{name} (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Graf Marimekko %{categories} podle %{values}',
	'LIVE_marimekko_has_mapping_numbered': 'Graf Marimekko %{categories} podle %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Prázdný graf Marimekko',
	'LIVE_marimekko_no_mapping_numbered': 'Prázdný graf Marimekko (%{number})',
	'LIVE_marimekko_named': 'Graf Marimekko %{name}',
	'LIVE_marimekko_numbered': 'Graf Marimekko %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Paprskový graf %{values}',
	'LIVE_sunburst_has_mapping_numbered': 'Paprskový graf %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Prázdný paprskový graf',
	'LIVE_sunburst_no_mapping_numbered': 'Prázdný paprskový graf (%{number})',
	'LIVE_sunburst_named': 'Paprskový graf %{name}',
	'LIVE_sunburst_named_numbered': 'Paprskový graf %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Analytický diagram driveru %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Analytický diagram driveru %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Prázdný analytický diagram driveru',
	'LIVE_decision_analysis_no_mapping_numbered': 'Prázdný analytický diagram driveru (%{number})',
	'LIVE_decision_analysis_named': 'Analytický diagram driveru %{name}',
	'LIVE_decision_analysis_named_numbered': 'Analytický diagram driveru %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Čárový a sloupcový graf: %{categories} podle %{columnValue} a %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': 'Čárový a sloupcový graf: %{categories} podle %{columnValue} a %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Čárový a sloupcový graf: %{columnValue} a %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': 'Čárový a sloupcový graf: %{categories} podle %{columnValue} a %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Prázdný čárový a sloupcový graf',
	'LIVE_line_column_no_mapping_numbered': 'Prázdný čárový a sloupcový graf (%{number})',
	'LIVE_line_column_named': 'Čárový a sloupcový graf: %{name}',
	'LIVE_line_column_named_numbered' : 'Čárový a sloupcový graf: %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Bublinový graf: %{x} podle %{y} a %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': 'Bublinový graf: %{x} podle %{y} a %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Prázdný bublinový graf',
	'LIVE_bubble_chart_no_mapping_numbered': 'Prázdný bublinový graf (%{number})',
	'LIVE_bubble_chart_named': 'Bublinový graf %{name}',
	'LIVE_bubble_chart_named_numbered': 'Bublinový graf %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Střelový graf %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Střelový graf %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Prázdný střelový graf',
	'LIVE_bullet_no_mapping_numbered': 'Prázdný střelový graf (%{number})',
	'LIVE_bullet_named': 'Střelový graf %{name}',
	'LIVE_bullet_named_numbered': 'Střelový graf %{name} (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Data v tomto panelu dashboard poskytuje',
	'showFooterToggleButtonText': 'Zobrazit zápatí',
	'showFooterSectionText': 'Zápatí'

});
